import React, { useState, useEffect } from 'react'
import contentdata from '../assets/contentdata.json'
import ProgramCard from '../components/ProgramCard'
import { Link } from "react-router-dom";
import axios from 'axios';
import LandingProgramCard from '../components/LandingProgramCard';
import Loader from '../components/Loader';
import SessionGameBanner from '../components/SessionGameBanner';


const Programs = () => {
    const [landingcards, setLandingcards] = useState([])
    const [instituionaloffers, setInstituationaloffers] = useState([])
    const [kidsprograms, setKidsprograms] = useState([])
    const [teensprograms, setTeensprograms] = useState([])
    const [otherprograms, setOtherprograms] = useState([])
    const [loading, setLoading] = useState(true)

    const data = contentdata;

    // useEffect(() => {
    //     setLandingcards(data.landingcards)
    //     // setInstituationaloffers(data.institutional_offerings)
    //     // setFeaturecards(data.featurecards)
    //     // setFeaturevideos(data.featurevideos)
    //     // setParentsspeak(data.parentsspeak)
    // }, [])

    useEffect(() => {
        getApidata()
    }, [])

    const getApidata = async () => {
        try {
            const urls = ['/programs?program_category=2,3&acf_format=standard', '/programs?program_category=4,5&acf_format=standard', '/pages?include=87,91,89,85&acf_format=standard']; // replace with your API URLs
            const requests = urls.map(url => axios.get(url));
            const responses = await Promise.all(requests);
            // console.log(responses)
            setKidsprograms(responses[0].data);
            setTeensprograms(responses[1].data);
            setOtherprograms(responses[2].data);
            setLoading(false);
        } catch (error) {
            console.error("Error fetching data", error);
            // handle error
        }
    }

    const InstitutionalProgramCard = ({ cardinfo }) => {
        // console.log(cardinfo)

        return (
            <Link to={`/corporate/${cardinfo.slug}`}>
                <div className='m-2 pt-[25px] px-[15px] pb-[5px] rounded-lg min-h-[150px] border-[2px] border-[#902C94]' >
                    <div className='flex justify-center'>
                        <img src={cardinfo.acf.icon_program} width={85} alt={cardinfo.title.rendered} className='pb-[15px]' />
                    </div>
                    <p className='brand-font txt-bold text-[16px] leading-[18px] text-center'>{cardinfo.title.rendered}</p>
                </div>
            </Link>
        )
    }


    return (
        <>
            {
                loading ? <Loader /> :
                    <div>
                        {/* page heading */}
                        <div className='spacer'>
                            <p className='gradient-heading brand-text'>Growing up with Yancha : Time-tested concepts and expert guidance for institutions and individuals</p>
                        </div>

                        <div className='spacer'>
                            <SessionGameBanner />
                        </div>

                        {/* program cards */}
                        <div className='spacer'>
                            <p className='gradient-heading brand-text bottom7px'>Yancha Kids - Develop Behaviour</p>
                            <div className='spacer flex flex-row flex-wrap -m-2'>
                                {
                                    kidsprograms.map(details => (
                                        <div className='w-1/2'>
                                            <LandingProgramCard cardinfo={details} />
                                        </div>
                                    ))
                                }
                            </div>
                        </div>

                        <div className='spacer'>
                            <p className='gradient-heading brand-text bottom7px'>Yancha Teens - Focus & Build</p>
                            <div className='spacer flex flex-row flex-wrap -m-2'>
                                {
                                    teensprograms.map(details => (
                                        <div className='w-1/2'>
                                            <LandingProgramCard cardinfo={details} />
                                        </div>
                                    ))
                                }
                            </div>
                        </div>

                        <div className='spacer'>
                            <p className='gradient-heading brand-text bottom7px'>Institutional Offerings</p>
                            <div className='spacer flex flex-row flex-wrap -m-2'>
                                {
                                    otherprograms.map(details => (
                                        <div className='w-1/2'>
                                            <InstitutionalProgramCard cardinfo={details} />
                                        </div>
                                    ))
                                }
                            </div>
                        </div>

                    </div>
            }
        </>
    )
}

export default Programs